import {Component, isDevMode, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {FormControl} from "@angular/forms";
import {Subject} from "rxjs/internal/Subject";
import {takeUntil} from "rxjs/internal/operators/takeUntil";
import firebase from 'firebase/compat';
import {MatSelectChange} from "@angular/material/select";
import {Observable} from "rxjs";

import * as XLSX from "xlsx";
import {saveAs} from "file-saver";
import {Workbook} from "exceljs";
import Timestamp = firebase.firestore.Timestamp;
import {DatePipe} from "@angular/common";
import {
  logExperimentalWarnings
} from "@angular-devkit/build-angular/src/builders/browser-esbuild/experimental-warnings";
import {Centre} from "../../../../interfaces/Centres";
import {FullChild} from "../../../../interfaces/FullChild";
import {environment} from "../../../../../environments/environment";
import {CentreService} from "../../../../services/centre.service";
import {LogService} from "../../../../services/log.service";
import {ChildService} from "../../../../components/child/child.service";
import {
  FinancialYearReport
} from "../../../../components/dashboard/financial-report-table/financial-report-table.component";
import {WeeklyReport} from "../weekly-reports/weekly-reports.component";
import {PermissionType} from "../../../../components/employee/PermissionType.enum";
import {FinancialYearService} from "../../../../services/financial-year.service";

@Component({
  selector: 'app-admission-records',
  templateUrl: './admission-records.component.html',
  styleUrls: ['./admission-records.component.scss']
})
export class AdmissionRecordsComponent implements OnInit, OnDestroy {
  readonly env = isDevMode() ? environment.testMode : environment.productionMode;

  /**
   * true  → count from ALAdmissionCycles (one doc per stay; each stay attributed
   *         to the centre where it happened — per-stay attribution)
   * false → legacy path: derive counts from ALChild.admissionData, attributing a
   *         child's whole history to their CURRENT centre (root centreCode,
   *         which reAdmissionProcess overwrites on every follow-up)
   */
  useCycles = true;
  private static readonly INACTIVE_CENTRE_CODES = ['ALGhatla', 'ALThane', 'ALBandra', 'ALAndheri'];

  financialData: any[] = []
  destroyed$ = new Subject()
  heading = ''
  sortBy: "byDate" | 'byYear' | 'byCentre' = 'byYear'
  startDate: Date = new Date('2024-04-01')
  endDate: Date = new Date('2025-03-31')
  selectCentre = new FormControl('All')
  sortBySelect = new FormControl(this.sortBy)
  centres$: Observable<Centre[]>

  selectedCentre:any;
  displayCentre = (c: any) => c?.centreName;
  selectedCentres: string[] = ['All']
  fileName = 'Admission_Report.xlsx';
  child: FullChild[] = []
  dataSource = new MatTableDataSource(this.financialData);
  select = new FormControl('Please Select')
  admissionsCountChildarray: FullChild[] = []
  dischargeCountChildArray: FullChild[] = []
  followUpCountChildArray: FullChild[] = []
  followUpOutCountChildArray: FullChild[] = []
  showLog = isDevMode()
  exportFollowUpAdmissionData: FullChild[] = []
  exportFollowUpDischargeData: FullChild[] = []
  isLoading: boolean = false;
  showInactiveCentres = false
  displayedColumns: string[] = ['centreName', 'new_admission', 'discharge', 'follow_up_admission', 'follow_up_discharge'];

  constructor(private readonly mFirestore: AngularFirestore,
              private readonly mCentreService: CentreService,
              private readonly mLogService: LogService,
              private readonly datePipe: DatePipe,
              private readonly financialYearService: FinancialYearService,
              private readonly mChildServie: ChildService) {
    this.centres$ = this.mCentreService.getAllCentres()
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate = fy.startDate;
    this.endDate = fy.endDate;
    setTimeToMidnight(this.startDate)
    // setTimeToMidnight(this.endDate)
    // alert('admission records')
  }


  clearAll() {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate = fy.startDate;
    this.endDate = fy.endDate;

    // this.selectedCentres = [];
    this.dataSource = new MatTableDataSource<any>([]);
    this.admissionsCountChildarray = [];
    this.dischargeCountChildArray = [];
    this.followUpCountChildArray = [];
    this.followUpOutCountChildArray = [];
    this.exportFollowUpAdmissionData = [];
    this.exportFollowUpDischargeData = [];
    this.selectedCentres = ['All']
    // this.selectedCentre=[];

    this.selectedCentre = null;
  }

  ngOnInit(): void {
    // this.getData()
  }

  // onCentreSelect(selectedCentre: Centre) {
  //   if (!selectedCentre) return;
  //
  //   console.log("Selected Centre:", selectedCentre);
  //
  //   this.selectedCentre = selectedCentre;
  //   this.selectedCentres = [selectedCentre.centreCode];
  //
  // }

  onCentreSelect(selectedCentres: Centre | Centre[]) {
    if (!selectedCentres) return;

    if (Array.isArray(selectedCentres)) {
      this.selectedCentre = selectedCentres;
      this.selectedCentres = selectedCentres.map(c => c.centreCode);
    } else {
      this.selectedCentre = selectedCentres;
      this.selectedCentres = [selectedCentres.centreCode];
    }

    console.log("Selected Centres:", this.selectedCentres);
  }

  calculateData(child: FullChild[], centreName: string, centreCode: string, startDate: Date, endDate: Date) {
    console.log('FINANCIAL DATA', child.length)

    let admission = child.filter((c) => c.centreCode == centreCode && c.dateOfAdmission.toDate() > startDate && c.dateOfAdmission.toDate() < endDate)
    let discharge = child.filter((c) => c.centreCode == centreCode && c.dateOfAdmission.toDate() > startDate && c.dateOfAdmission.toDate() < endDate && c.admissionData.length == 2)
    let follow_up_admission = child.filter((c) => c.centreCode == centreCode && c.dateOfAdmission.toDate() > startDate && c.dateOfAdmission.toDate() < endDate && c.admissionData.length >= 3 && c.admissionData.length % 2 !== 0)
    let follow_up_discharge = child.filter((c) => c.centreCode == centreCode && c.dateOfAdmission.toDate() > startDate && c.dateOfAdmission.toDate() < endDate && c.admissionData.length >= 3 && c.admissionData.length % 2 === 0)

    console.log('Admission', admission.length)
    console.log('Discharge', discharge.length)
    console.log('follow_up_admission', follow_up_admission.length)
    console.log('follow_up_discharge', follow_up_discharge.length)
    console.log(admission)
    let pune: FinancialYearReport = {
      centreName: centreName,
      new_admission: admission.length,
      discharge: discharge.length,
      follow_up_admission: follow_up_admission.length,
      follow_up_discharge: follow_up_discharge.length,
    }
    this.financialData.push(pune)
  }

  calculateData3(child: FullChild[], centreName: string, centreCode: string, startDate: Date, endDate: Date) {
    let admission: FullChild[] = []
    let discharge: FullChild[] = []
    let firstAdmission = 0
    let firstDischarge = 0
    let admissionCount = 0
    let dischargeCount = 0
    let admittedChildTable: { centreName: string; childCode: string; doa: Date }[] = []
    child.forEach(c => {
      try {
        c.admissionData.length!
      } catch (e) {
        console.log(e, c.childCode)
      }
    })
    // console.log('FINANCIAL DATA', child.length)
    try {
      admission = child.filter((c) => c.centreCode == centreCode && c.dateOfAdmission.toDate() >= startDate && c.dateOfAdmission.toDate() <= endDate)

    } catch (reason) {
      console.log('====ERROR======', child)
    }
    let admissionDates = admission.map(m => m.childCode)
    // let discharge = child.filter((c) => c.centreCode == centreCode && c.dateOfAdmission.toDate() > startDate && c.dateOfAdmission.toDate() < endDate && c.admissionData.length >= 2)
    discharge = child.filter((c) => c.centreCode == centreCode && c.admissionData.length >= 2 && c.admissionData?.[1]?.dateOfDischarge?.toDate() >= startDate && c.admissionData?.[1]?.dateOfDischarge?.toDate() <= endDate)
    // let follow_up_admission = child.filter((c) => c.centreCode == centreCode && c.dateOfAdmission.toDate() > startDate && c.dateOfAdmission.toDate() < endDate && c.admissionData.length >= 3 && c.admissionData.length % 2 !== 0)
    try {
      discharge = child.filter((c) => c.centreCode == centreCode && c.admissionData.length >= 2 && c.admissionData?.[1]?.dateOfDischarge?.toDate() >= startDate && c.admissionData?.[1]?.dateOfDischarge?.toDate() <= endDate)


    } catch (reason) {
      console.log('====ERROR======', child)
    }

    let follow_up_admission = child.filter((c) => c.centreCode == centreCode)

    follow_up_admission.forEach(c => {

      c.admissionData.forEach((ad, index) => {
        if (index == 0) {
          if (c.dateOfAdmission.toDate() >= startDate && c.dateOfAdmission.toDate() <= endDate) {
            firstAdmission++
            this.admissionsCountChildarray.push(c)
          }


          // if(  c.dateOfAdmission.toDate() >= startDate && c.dateOfAdmission.toDate() <= endDate)         admittedChildTable.push({centreName:centreName,childCode: c.childCode,doa: c.dateOfAdmission.toDate()})


        }
        if (index == 1) {
          // @ts-ignore
          if (ad.dateOfDischarge.toDate() >= startDate && ad.dateOfDischarge.toDate() <= endDate) {
            firstDischarge++
            this.dischargeCountChildArray.push(c)
          }

          // @ts-ignore
          // * To show Discharge Count Table
          // if (ad.dateOfDischarge?.toDate() >= startDate && ad.dateOfDischarge.toDate() <= endDate) admittedChildTable.push({
          //     centreName: centreName,
          //     childCode: c.childCode,
          //     doa: ad.dateOfDischarge!.toDate()
          // })

        }
        try {


          if (index >= 2 && index % 2 == 0) {
            // console.log(ad.dateOfAdmission?.toDate())
            const d = ad?.dateOfAdmission?.toDate();
            // @ts-ignore
            if (d => startDate && d <= endDate) {
              admissionCount++
              this.followUpCountChildArray.push(c)
            }
          }
        } catch (e: any) {
          alert(c.childCode + "ERROR " + e)
        }
        if (index > 2 && index % 2 != 0) {
          let d = ad.dateOfDischarge?.toDate()!
          // @ts-ignore
          if (d => startDate && d <= endDate) {
            dischargeCount++
            this.followUpOutCountChildArray.push(c)
          }
          // console.log(d)

        }
      })
    })
    //  console.assessment-table(admittedChildTable)
    // alert(`START DATE = ${startDate} END DATE: ${endDate} Admission ${admission.length} Discharge: ${discharge.length} Follow Up Admission ${admissionCount} Followup Discharge ${dischargeCount}`)

    // let follow_up_discharge = child.filter((c) => c.centreCode == centreCode && c.dateOfAdmission.toDate() > startDate && c.dateOfAdmission.toDate() < endDate && c.admissionData.length >= 3 && c.admissionData.length % 2 === 0)
    // console.log('Admission', admission.length)
    // console.log('Admission', admissionDates)
    // console.log('Discharge', discharge.length)
    // console.log('follow_up_admission', follow_up_admission.length)
    // console.log('follow_up_discharge', follow_up_discharge.length)
    // console.log(admission)
    let pune: FinancialYearReport = {
      centreName: centreName,
      new_admission: firstAdmission,
      discharge: firstDischarge,
      follow_up_admission: admissionCount,
      follow_up_discharge: dischargeCount
    }

    this.financialData.push(pune)
  }

  calculateData2gemini(child: FullChild[], centreName: string, centreCode: string, startDate: Date, endDate: Date) {
    const filteredAdmission = child.filter(
      (c) =>
        c.centreCode === centreCode &&
        c.dateOfAdmission.toDate() >= startDate &&
        c.dateOfAdmission.toDate() <= endDate
    );

    const filteredDischarge = child.filter(
      (c) =>
        c.centreCode === centreCode &&
        c.admissionData.length >= 2 &&
        c.admissionData?.[1]?.dateOfDischarge?.toDate() >= startDate &&
        c.admissionData?.[1]?.dateOfDischarge?.toDate() <= endDate
    );

    const followUpAdmissionCount = filteredAdmission.reduce((count, c) => {
      if (c.dateOfAdmission.toDate() >= startDate && c.dateOfAdmission.toDate() <= endDate) {
        count++;
        this.admissionsCountChildarray.push(c);
      }
      return count;
    }, 0);

    const followUpDischargeCount = filteredAdmission.reduce((count, c) => {
      c.admissionData.forEach((ad, index) => {
        if (index > 1 && index % 2 !== 0) {
          const dischargeDate = ad.dateOfDischarge?.toDate();
          if (dischargeDate && dischargeDate >= startDate && dischargeDate <= endDate) {
            count++;
            this.followUpOutCountChildArray.push(c);
          }
        }
      });
      return count;
    }, 0);

    const pune: FinancialYearReport = {
      centreName: centreName,
      new_admission: filteredAdmission.length,
      discharge: filteredDischarge.length,
      follow_up_admission: followUpAdmissionCount,
      follow_up_discharge: followUpDischargeCount
    };

    this.financialData.push(pune);

    // Consider error handling or logging for unexpected data (e.g., missing date properties)
    // You might want to handle cases where admissionData.length is less than 2 for discharge filter
    // Also, review logging approach (alert vs. more structured logging)
  }

  calculateData20(child: FullChild[], centreName: string, centreCode: string, startDate: Date, endDate: Date) {
    let admission: FullChild[] = []
    let discharge: FullChild[] = []
    let firstAdmission = 0
    let firstDischarge = 0
    let admissionCount = 0
    let dischargeCount = 0
    let admittedChildTable: { centreName: string; childCode: string; doa: Date }[] = []
    //If child Data is not available
    child.forEach(c => {
      try {
        c.admissionData.length!
      } catch (e) {
        console.log(e, c.childCode)
      }
    })
    // console.log('FINANCIAL DATA', child.length)
    try {
      admission = child.filter((c) => c.centreCode == centreCode && c.dateOfAdmission.toDate() >= startDate && c.dateOfAdmission.toDate() <= endDate)
    } catch (reason) {
      console.log('====ERROR======', child)
    }
    let admissionDates = admission.map(m => m.childCode)
    // let discharge = child.filter((c) => c.centreCode == centreCode && c.dateOfAdmission.toDate() > startDate && c.dateOfAdmission.toDate() < endDate && c.admissionData.length >= 2)
    // discharge = child.filter((c) => c.centreCode == centreCode && c.admissionData.length >= 2 && c.admissionData[1].dateOfDischarge!.toDate() >= startDate && c.admissionData[1].dateOfDischarge!.toDate() <= endDate)
    // let follow_up_admission = child.filter((c) => c.centreCode == centreCode && c.dateOfAdmission.toDate() > startDate && c.dateOfAdmission.toDate() < endDate && c.admissionData.length >= 3 && c.admissionData.length % 2 !== 0)
    try {
      discharge = child.filter((c) => c.centreCode == centreCode && c.admissionData.length >= 2 && c.admissionData?.[1]?.dateOfDischarge?.toDate() >= startDate && c.admissionData?.[1]?.dateOfDischarge?.toDate() <= endDate)


    } catch (reason) {
      console.log('====ERROR======', child)
    }

    let follow_up_admission = child.filter((c) => c.centreCode == centreCode)


    follow_up_admission.forEach(c => {
      try {


        c.admissionData.forEach((ad, index) => {
          if (index == 0) {
            if (c.dateOfAdmission.toDate() >= startDate && c.dateOfAdmission.toDate() <= endDate) {
              firstAdmission++
              this.admissionsCountChildarray.push(c)
            }


            // if(  c.dateOfAdmission.toDate() >= startDate && c.dateOfAdmission.toDate() <= endDate)         admittedChildTable.push({centreName:centreName,childCode: c.childCode,doa: c.dateOfAdmission.toDate()})


          }
          if (index == 1) {
            // @ts-ignore
            if (ad.dateOfDischarge.toDate() >= startDate && ad.dateOfDischarge.toDate() <= endDate) {
              firstDischarge++
              this.dischargeCountChildArray.push(c)
            }

            // @ts-ignore
            // * To show Discharge Count Table
            // if (ad.dateOfDischarge?.toDate() >= startDate && ad.dateOfDischarge.toDate() <= endDate) admittedChildTable.push({
            //     centreName: centreName,
            //     childCode: c.childCode,
            //     doa: ad.dateOfDischarge!.toDate()
            // })

          }
          try {


            if (index >= 2 && index % 2 == 0) {
              // console.log(ad.dateOfAdmission?.toDate())
              const d = ad?.dateOfAdmission?.toDate();
              if (d && d >= startDate && d <= endDate) {

                admissionCount++
                this.followUpCountChildArray.push(c)
              }
            }
          } catch (e: any) {
            alert(c.childCode + "ERROR " + e)
          }
          if (index > 2 && index % 2 != 0) {
            const d = ad?.dateOfDischarge?.toDate();
            if (d && d >= startDate && d <= endDate) {
              dischargeCount++
              this.followUpOutCountChildArray.push(c)
            }
            // console.log(d)

          }
        })
      } catch (e: any) {
        alert('Error at '+c.childCode +'as'+e.message);
      }
    })

    //  console.assessment-table(admittedChildTable)
    // alert(`START DATE = ${startDate} END DATE: ${endDate} Admission ${admission.length} Discharge: ${discharge.length} Follow Up Admission ${admissionCount} Followup Discharge ${dischargeCount}`)

    // let follow_up_discharge = child.filter((c) => c.centreCode == centreCode && c.dateOfAdmission.toDate() > startDate && c.dateOfAdmission.toDate() < endDate && c.admissionData.length >= 3 && c.admissionData.length % 2 === 0)
    // console.log('Admission', admission.length)
    // console.log('Admission', admissionDates)
    // console.log('Discharge', discharge.length)
    // console.log('follow_up_admission', follow_up_admission.length)
    // console.log('follow_up_discharge', follow_up_discharge.length)
    // console.log(admission)
    let pune: FinancialYearReport = {
      centreName: centreName,
      new_admission: firstAdmission,
      discharge: firstDischarge,
      follow_up_admission: admissionCount,
      follow_up_discharge: dischargeCount
    }

    this.financialData.push(pune)
  }

  calculateData2(child: FullChild[], centreName: string, centreCode: string, startDate: Date, endDate: Date) {
    let admission: FullChild[] = []
    let discharge: FullChild[] = []
    let firstAdmission = 0
    let firstDischarge = 0
    let admissionCount = 0
    let dischargeCount = 0

    let admittedChildTable: { centreName: string; childCode: string; doa: Date }[] = []
    //If child Data is not available
    child.forEach(c => {
      try {
        c.admissionData.length!
      } catch (e) {
        console.log(e, c.childCode)
      }
    })
    try {
      admission = child.filter((c) => c.centreCode == centreCode && c.dateOfAdmission.toDate() >= startDate && c.dateOfAdmission.toDate() <= endDate)
    } catch (reason) {
      console.log('====ERROR======', child)
    }

    // try {
    //   discharge = child.filter((c) => c.centreCode == centreCode && c.admissionData.length >= 2 && c.admissionData?.[1]?.dateOfDischarge?.toDate() >= startDate && c.admissionData?.[1]?.dateOfDischarge?.toDate() <= endDate)
    //
    //
    // } catch (reason) {
    //   console.log('====ERROR======', child)
    // }

    discharge = child.filter(c => {
      const dischargeDate = c.admissionData?.[1]?.dateOfDischarge?.toDate();
      return (
        c.centreCode === centreCode &&
        dischargeDate !== undefined &&
        dischargeDate >= startDate &&
        dischargeDate <= endDate
      );
    });


    let follow_up_admission = child.filter((c) => c.centreCode == centreCode)


    follow_up_admission.forEach(c => {
      try {


        c.admissionData.forEach((ad, index) => {
          if (index == 0) {
            if (c.dateOfAdmission.toDate() >= startDate && c.dateOfAdmission.toDate() <= endDate) {
              firstAdmission++
              this.admissionsCountChildarray.push(c)
            }


            // if(  c.dateOfAdmission.toDate() >= startDate && c.dateOfAdmission.toDate() <= endDate)         admittedChildTable.push({centreName:centreName,childCode: c.childCode,doa: c.dateOfAdmission.toDate()})


          }
          // if (index == 1) {
          //   // @ts-ignore
          //   if (ad.dateOfDischarge.toDate() >= startDate && ad.dateOfDischarge.toDate() <= endDate) {
          //     firstDischarge++
          //     this.dischargeCountChildArray.push(c)
          //   }

          if (index === 1) {
            const dischargeDate = ad?.dateOfDischarge?.toDate();
            if (dischargeDate && dischargeDate >= startDate && dischargeDate <= endDate) {
              firstDischarge++;
              this.dischargeCountChildArray.push(c);
            }



          // @ts-ignore
            // * To show Discharge Count Table
            // if (ad.dateOfDischarge?.toDate() >= startDate && ad.dateOfDischarge.toDate() <= endDate) admittedChildTable.push({
            //     centreName: centreName,
            //     childCode: c.childCode,
            //     doa: ad.dateOfDischarge!.toDate()
            // })

          }
          try {


            if (index >= 2 && index % 2 === 0) {
              const d = ad?.dateOfAdmission?.toDate();
              if (d && d >= startDate && d <= endDate) {
                admissionCount++;
                this.followUpCountChildArray.push(c);
              }
            }
          } catch (e: any) {
            alert(c.childCode + "ERROR " + e)
          }
          if (index > 1 && index % 2 !== 0) {
            const d = ad?.dateOfDischarge?.toDate();
            if (d && d >= startDate && d <= endDate) {
              dischargeCount++;
              this.followUpOutCountChildArray.push(c);
            }
          }
        })
      } catch (e: any) {
        alert('Error at '+c.childCode +'as'+e.message);
      }
    })

    let pune: FinancialYearReport = {
      centreName: centreName,
      new_admission: firstAdmission,
      discharge: firstDischarge,
      follow_up_admission: admissionCount,
      follow_up_discharge: dischargeCount
    }

    this.financialData.push(pune)
  }





  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  selectYear($event: any) {
    if ($event.value == '2022') {
      // alert(2022)
      this.heading = 'April 2022 - March 2023'
      this.startDate = new Date('2022-04-01')
      this.endDate = new Date('2023-03-31')
      setTimeToMidnight(this.startDate)
      setTimeToMidnight(this.endDate)

      if (this.child.length == 0) {
        this.getData()
      } else this.calculateCentreData(2022)
    } else if ($event.value == '2021') {
      this.startDate = new Date('2021-04-01')
      this.endDate = new Date('2022-03-31')
      setTimeToMidnight(this.startDate)
      setTimeToMidnight(this.endDate)

      if (this.child.length == 0) {
        this.getData()
      } else this.calculateCentreData(2021)
      // alert(2021)
      this.heading = 'April 2021 - March 2022'
    } else if ($event.value == '2020') {
      this.startDate = new Date('2020-04-01')
      this.endDate = new Date('2021-03-31')
      setTimeToMidnight(this.startDate)
      setTimeToMidnight(this.endDate)

      // alert(2020)
      this.heading = 'April 2020 - March 2021'
      if (this.child.length == 0) {
        this.getData()
      } else this.calculateCentreData(2020)
    } else if ($event.value == '2023') {
      this.startDate = new Date('2023-04-01')
      this.endDate = new Date('2024-03-31')
      setTimeToMidnight(this.startDate)
      setTimeToMidnight(this.endDate)

      // alert(2020)
      this.heading = 'April 2023 - March 2024'
      if (this.child.length == 0) {
        this.getData()
      } else this.calculateCentreData(2023)
    } else if ($event.value == '2019') {
      this.startDate = new Date('2019-04-01')
      this.endDate = new Date('2020-03-31')
      setTimeToMidnight(this.startDate)
      setTimeToMidnight(this.endDate)

      // alert(2020)
      this.heading = 'April 2019 - March 2020'
      if (this.child.length == 0) {
        this.getData()
      } else this.calculateCentreData(2019)
    } else if ($event.value == '2018') {
      this.startDate = new Date('2018-04-01')
      this.endDate = new Date('2019-03-31')
      setTimeToMidnight(this.startDate)
      setTimeToMidnight(this.endDate)

      // alert(2020)
      this.heading = 'April 2018 - March 2019'
      if (this.child.length == 0) {
        this.getData()
      } else this.calculateCentreData(2018)
    } else if ($event.value == '2017') {
      this.startDate = new Date('2017-04-01')
      this.endDate = new Date('2018-03-31')
      setTimeToMidnight(this.startDate)
      setTimeToMidnight(this.endDate)

      // alert(2020)
      this.heading = 'April 2017 - March 2018'
      if (this.child.length == 0) {
        this.getData()
      } else this.calculateCentreData(2017)
    } else if ($event.value == '2016') {
      this.startDate = new Date('2016-04-01')
      this.endDate = new Date('2017-03-31')
      setTimeToMidnight(this.startDate)
      setTimeToMidnight(this.endDate)

      // alert(2020)
      this.heading = 'April 2016 - March 2017'
      if (this.child.length == 0) {
        this.getData()
      } else this.calculateCentreData(2016)
    } else if ($event.value == '2015') {
      this.startDate = new Date('2015-04-01')
      this.endDate = new Date('2016-03-31')
      setTimeToMidnight(this.startDate)
      setTimeToMidnight(this.endDate)

      // alert(2020)
      this.heading = 'April 2015 - March 2016'
      if (this.child.length == 0) {
        this.getData()
      } else this.calculateCentreData(2015)
    } else if ($event.value == '2014') {
      this.startDate = new Date('2014-06-01')
      this.endDate = new Date('2015-03-31')
      setTimeToMidnight(this.startDate)
      setTimeToMidnight(this.endDate)

      // alert(2020)
      this.heading = 'April 2014 - March 2015'
      if (this.child.length == 0) {
        this.getData()
      } else this.calculateCentreData(2014)
    } else if ($event.value == '2015') {
      this.startDate = new Date('2023-04-01')
      this.endDate = new Date('2024-03-31')
      setTimeToMidnight(this.startDate)
      setTimeToMidnight(this.endDate)

      // alert(2020)
      this.heading = `From ${this.startDate.toDateString()} To ${this.endDate.toDateString()} `
      // this.getData()

    } else if ($event.value == 'Please Select') {
      // this.startDate = new Date('2020-04-23')
      // this.endDate = new Date('2021-03-24')
      // alert(2020)
      this.heading = `From ${this.startDate.toDateString()} To ${this.endDate.toDateString()} `
      // this.getData()
    }
  }

  async getData(): Promise<void> {
    //* GETTING ALL CHILD DATA
    return new Promise((resolve, reject) => {
      this.mChildServie.getLatestData().pipe(takeUntil(this.destroyed$))
        .subscribe({
          next: (c) => {
            this.child = c.docs.map(c => c.data());
            this.calculateCentreData(2022);
            this.isLoading = false;
            resolve();  // Resolve when data fetching is complete
          },
          error: (err) => reject(err)  // Reject if there’s an error
        });
    });
  }


  ngOnDestroy(): void {
    this.destroyed$.next(null)
    this.destroyed$.complete()
  }

  showSelections($event: MatSelectChange) {
    //    console.log('SORT BY', $event.value)
    this.sortBy = $event.value

  }

  async searchByDate() {
    if (this.useCycles) {
      await this.searchFromCycles();
      return;
    }
    if (this.startDate && this.endDate && this.selectedCentres.length > 0) {
      this.financialData = [];
      this.admissionsCountChildarray = [];
      this.dischargeCountChildArray = [];
      this.followUpCountChildArray = [];
      this.followUpOutCountChildArray = [];
      this.exportFollowUpAdmissionData = [];
      this.exportFollowUpDischargeData = [];
      this.isLoading = true;

      if (this.child.length === 0) {
        await this.getData();
      }

      if (isNaN(this.startDate.getTime()) || isNaN(this.endDate.getTime())) {
        alert('Invalid date range');
        this.isLoading = false;
        return;
      }

      const allCentreCodes = [
        { name: 'AL Gurunanak Niwas', code: 'ALGurunanak' },
        { name: 'AL Diamond Garden', code: 'ALDiamondGarden' },
        { name: 'AL Pune', code: 'ALPune' },
        { name: 'AL Coimbatore', code: 'ALCoimbatore' },
        { name: 'AL Manipal', code: 'ALManipal' },
        { name: 'AL Chandigarh', code: 'ALChandigarh' },
        { name: 'AL Ahmedabad', code: 'ALAhmedabad' },
        { name: 'AL Bangalore', code: 'ALBangalore' },
        { name: 'AL Madurai', code: 'ALMadurai' },
        { name: 'AL Borivali', code: 'ALBorivali' },
        { name: 'AL Sandu Garden', code: 'ALSanduGarden' },
        { name: 'AL Silchar', code: 'ALSilchar' },
      ];

      if (this.showInactiveCentres) {
        allCentreCodes.push({ name: 'AL Ghatla', code: 'ALGhatla' });
        allCentreCodes.push({ name: 'AL Thane', code: 'ALThane' });
        allCentreCodes.push({ name: 'AL Bandra', code: 'ALBandra' });
        allCentreCodes.push({ name: 'AL Andheri', code: 'ALAndheri' });
      }

      if (this.selectedCentres.includes('All')) {
        this.selectedCentres = ['All'];
      }

      const centresToUse = this.selectedCentres.includes('All') || this.selectedCentres.length === 0
        ? allCentreCodes
        : allCentreCodes.filter(c => this.selectedCentres.includes(c.code));

      for (const centre of centresToUse) {
        this.financialData = this.financialData.filter(d => d.centreName !== centre.name);
        this.calculateData2(this.child, centre.name, centre.code, this.startDate, this.endDate);
      }

      await this.getTotalDataThenSetDataSource();
      this.isLoading = false;
    }
  }

  // async searchByDate() {
  //   if (this.startDate && this.endDate && this.selectedCentres.length > 0) {
  //     this.financialData = [];
  //     this.isLoading = true;
  //
  //     if (this.child.length === 0) {
  //       await this.getData();
  //     }
  //     // ✅ ADD THIS BLOCK AT THE VERY TOP
  //     if (isNaN(this.startDate.getTime()) || isNaN(this.endDate.getTime())) {
  //       alert('Invalid date range');
  //       return;
  //     }
  //
  //     const allCentreCodes = [
  //       { name: 'AL Gurunanak Niwas', code: 'ALGurunanak' },
  //       { name: 'AL Diamond Garden', code: 'ALDiamondGarden' },
  //       { name: 'AL Pune', code: 'ALPune' },
  //       { name: 'AL Coimbatore', code: 'ALCoimbatore' },
  //       { name: 'AL Manipal', code: 'ALManipal' },
  //       { name: 'AL Chandigarh', code: 'ALChandigarh' },
  //       { name: 'AL Ahmedabad', code: 'ALAhmedabad' },
  //       { name: 'AL Bangalore', code: 'ALBangalore' },
  //       { name: 'AL Madurai', code: 'ALMadurai' },
  //       { name: 'AL Borivali', code: 'ALBorivali' },
  //       { name: 'AL Sandu Garden', code: 'ALSanduGarden' },
  //       { name: 'AL Silchar', code: 'ALSilchar' },
  //     ];
  //
  //     if (this.showInactiveCentres) {
  //       allCentreCodes.push({ name: 'AL Ghatla', code: 'ALGhatla' });
  //       allCentreCodes.push({ name: 'AL Thane', code: 'ALThane' });
  //       allCentreCodes.push({ name: 'AL Bandra', code: 'ALBandra' });
  //       allCentreCodes.push({ name: 'AL Andheri', code: 'ALAndheri' });
  //     }
  //
  //     // Normalize selected centres
  //     if (this.selectedCentres.includes('All')) {
  //       this.selectedCentres = ['All'];
  //     }
  //
  //     // Loop and calculate
  //     const centresToUse = this.selectedCentres.includes('All') || this.selectedCentres.length === 0
  //       ? allCentreCodes
  //       : allCentreCodes.filter(c => this.selectedCentres.includes(c.code));
  //     // this.onStartDateChanged()
  //     // this.onEndDateChanged()
  //     for (const centre of centresToUse) {
  //       // Ensure no duplicate by removing existing entry (defensive)
  //       this.financialData = this.financialData.filter(d => d.centreName !== centre.name);
  //
  //       this.calculateData2(this.child, centre.name, centre.code, this.startDate, this.endDate);
  //     }
  //
  //     await this.getTotalDataThenSetDataSource();
  //     this.isLoading = false;
  //   }
  // }

  // ── NEW PATH: count from ALAdmissionCycles (per-stay centre attribution) ──
  //
  // One cycle doc per stay:  isFollowUp=false → cycle 1 (new admission),
  // isFollowUp=true → follow-up.  Each doc carries the centre where THAT stay
  // happened, so transfers no longer shift a child's history to their current
  // centre.  Two queries (automatic single-field indexes only), merged and
  // de-duplicated by doc id — a stay admitted AND discharged in range appears
  // in both snapshots but is classified exactly once.
  private async searchFromCycles(): Promise<void> {
    if (!this.startDate || !this.endDate) return;
    if (isNaN(this.startDate.getTime()) || isNaN(this.endDate.getTime())) {
      alert('Invalid date range');
      return;
    }

    this.financialData = [];
    this.admissionsCountChildarray = [];
    this.dischargeCountChildArray = [];
    this.followUpCountChildArray = [];
    this.followUpOutCountChildArray = [];
    this.isLoading = true;

    const rangeStart = new Date(new Date(this.startDate).setHours(0, 0, 0, 0));
    const rangeEnd = new Date(new Date(this.endDate).setHours(23, 59, 59, 999));

    // Three queries (mirroring AverageStayReportComponent's carry-forward
    // pattern), each needing only Firestore's automatic single-field indexes:
    //   1. admitted within range
    //   2. discharged on/after range start — covers discharges that fall
    //      inside the range AND carry-forward stays discharged after it
    //   3. still open (no discharge yet) — admission date filtered client-side
    // Merged and de-duplicated by doc id below. Carry-forward stays (admitted
    // before the range, still present when it opened) are folded into
    // New/Follow-Up Admission by their own isFollowUp type — not a separate
    // bucket — since they represent children present at that centre.
    try {
      const [admSnap, dischargedOnOrAfterSnap, openSnap] = await Promise.all([
        this.mFirestore.collection(this.env.admissionCycles, ref =>
          ref.where('dateOfAdmission', '>=', rangeStart)
             .where('dateOfAdmission', '<=', rangeEnd)
        ).get().toPromise(),
        this.mFirestore.collection(this.env.admissionCycles, ref =>
          ref.where('dateOfDischarge', '>=', rangeStart)
        ).get().toPromise(),
        this.mFirestore.collection(this.env.admissionCycles, ref =>
          ref.where('dateOfDischarge', '==', null)
        ).get().toPromise()
      ]);

      const cyclesById = new Map<string, any>();
      [admSnap, dischargedOnOrAfterSnap, openSnap].forEach(snap =>
        snap?.docs.forEach((d: any) => cyclesById.set(d.id, {id: d.id, ...d.data()}))
      );

      const useAll = this.selectedCentres.includes('All') || this.selectedCentres.length === 0;
      const centreRows = new Map<string, FinancialYearReport>();

      cyclesById.forEach(cycle => {
        const cc: string = cycle.centreCode || 'Unknown';
        if (!useAll && !this.selectedCentres.includes(cc)) return;
        if (useAll && !this.showInactiveCentres
          && AdmissionRecordsComponent.INACTIVE_CENTRE_CODES.includes(cc)) return;

        const adm = this.cycleDate(cycle.dateOfAdmission);
        const dis = this.cycleDate(cycle.dateOfDischarge);
        if (!adm) return;

        if (!centreRows.has(cc)) {
          centreRows.set(cc, {
            centreName: cycle.centreName || cc,
            new_admission: 0, discharge: 0,
            follow_up_admission: 0, follow_up_discharge: 0
          });
        }
        const row = centreRows.get(cc)!;

        const admittedInRange = adm >= rangeStart && adm <= rangeEnd;
        // Present when the window opened: admitted earlier, and either still
        // open or discharged on/after range start (so still there at the start).
        const isCarryForward = !admittedInRange && adm < rangeStart && (!dis || dis >= rangeStart);

        if (admittedInRange || isCarryForward) {
          if (cycle.isFollowUp) {
            row.follow_up_admission++;
            this.followUpCountChildArray.push(cycle);
          } else {
            row.new_admission++;
            this.admissionsCountChildarray.push(cycle);
          }
        }
        if (dis && dis >= rangeStart && dis <= rangeEnd) {
          if (cycle.isFollowUp) {
            row.follow_up_discharge++;
            this.followUpOutCountChildArray.push(cycle);
          } else {
            row.discharge++;
            this.dischargeCountChildArray.push(cycle);
          }
        }
      });

      this.financialData = Array.from(centreRows.values());
      this.getTotalDataThenSetDataSource();
    } catch (err) {
      console.error('searchFromCycles failed:', err);
      this.isLoading = false;
    }
  }

  private cycleDate(value: any): Date | null {
    if (!value) return null;
    if (value instanceof Date) return value;
    if (typeof value.toDate === 'function') return value.toDate();
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }

  /** Excel export for cycle-based download buttons (cycles lack the FullChild
   *  shape the legacy processObject() pipeline expects). */
  private exportCycleList(cycles: any[], filename: string): void {
    const rows = cycles.map(c => ({
      'Child Code': c.childCode,
      'Child Name': c.childName || `${c.firstName ?? ''} ${c.lastName ?? ''}`.trim(),
      'Centre': c.centreName,
      'Cycle #': c.cycleNumber,
      'Type': c.isFollowUp ? 'Follow-Up' : 'New',
      'Date of Admission': this.datePipe.transform(this.cycleDate(c.dateOfAdmission), 'dd/MM/yyyy') ?? '',
      'Date of Discharge': this.datePipe.transform(this.cycleDate(c.dateOfDischarge), 'dd/MM/yyyy') ?? '',
      'Status': c.dateOfDischarge ? 'Discharged' : 'Staying',
      'Gender': c.gender ?? '',
      'Hospital': c.hospital ?? '',
      'City': c.city ?? ''
    }));
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rows);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'data');
    XLSX.writeFile(wb, filename + '.xlsx');
  }

// Helper function to calculate data for centers
  private calculateDataForSelectedCentres(centres: string[], centresList: { name: string, code: string }[]) {
    centres.forEach(centreCode => {
      const centre = centresList.find(c => c.code === centreCode);
      if (centre) {
        this.calculateData2(this.child, centre.name, centre.code, this.startDate, this.endDate);
      }
    });
  }

  calculateCentreData(year: number) {
    this.isLoading = false;
    this.financialData = []
    if (this.selectedCentres.includes('ALGurunanak') || this.selectedCentres.length == 0) this.calculateData2(this.child, 'AL Gurunanak Niwas', 'ALGurunanak', this.startDate, this.endDate);
    if (this.selectedCentres.includes('ALDiamondGarden') || this.selectedCentres.length == 0) this.calculateData2.call(this, this.child, 'AL Diamond Garden', 'ALDiamondGarden', this.startDate, this.endDate);
    if (this.selectedCentres.includes('ALBandra') || this.selectedCentres.length == 0) this.calculateData2.call(this, this.child, 'AL Bandra', 'ALBandra', this.startDate, this.endDate);
    if (this.selectedCentres.includes('ALPune') || this.selectedCentres.length == 0) this.calculateData2.call(this, this.child, 'AL Pune', 'ALPune', this.startDate, this.endDate);
    if (this.selectedCentres.includes('ALManipal') || this.selectedCentres.length == 0) this.calculateData2.call(this, this.child, 'AL Manipal', 'ALManipal', this.startDate, this.endDate);
    if (this.selectedCentres.includes('ALChandigarh') || this.selectedCentres.length == 0) this.calculateData2(this.child, 'AL Chandigarh', 'ALChandigarh', this.startDate, this.endDate);
    if (this.selectedCentres.includes('ALCoimbatore') || this.selectedCentres.length == 0) this.calculateData2.call(this, this.child, 'AL Coimbatore', 'ALCoimbatore', this.startDate, this.endDate);
    // @ts-ignore
    //      if(year<=2017)     this.calculateData2(this.child, 'AL Andheri', 'ALAndheri', this.startDate, this.endDate);
    //      if(year<=2017)     this.calculateData2(this.child, 'AL Bandra', 'ALBandra', this.startDate, this.endDate);
    //           this.calculateData2(this.child, 'AL Bandra', 'ALBandra', this.startDate, this.endDate);
    //added by sumeet below 3 lines
    if (this.selectedCentres.includes('ALAhmedabad') || this.selectedCentres.length == 0) this.calculateData2(this.child, 'AL Ahmedabad', 'ALAhmedabad', this.startDate, this.endDate);
    if (this.selectedCentres.includes('ALBangalore') || this.selectedCentres.length == 0) this.calculateData2(this.child, 'AL Bangalore', 'ALBangalore', this.startDate, this.endDate);
    if (this.selectedCentres.includes('ALSanduGarden') || this.selectedCentres.length == 0) this.calculateData2(this.child, 'AL Sandu Garden', 'ALSanduGarden', this.startDate, this.endDate);
    if (this.selectedCentres.includes('ALBorivali') || this.selectedCentres.length == 0) this.calculateData2(this.child, 'AL Borivali', 'ALBorivali', this.startDate, this.endDate);
    if (this.selectedCentres.includes('ALSilchar') || this.selectedCentres.length == 0) this.calculateData2(this.child, 'AL Silchar', 'ALSilchar', this.startDate, this.endDate);
    if (this.selectedCentres.includes('ALNoida') || this.selectedCentres.length == 0) this.calculateData2(this.child, 'AL Noida', 'ALNoida', this.startDate, this.endDate);
    if (this.selectedCentres.includes('ALThiruvananthapuram') || this.selectedCentres.length == 0) this.calculateData2(this.child, 'AL Thiruvananthapuram', 'ALThiruvananthapuram', this.startDate, this.endDate);

    // if (this.startDate < new Date('2021-12-01') || this.showInactiveCentres) this.calculateData2(this.child, 'AL Ghatla', 'ALGhatla', this.startDate, this.endDate);
    // if (this.startDate < new Date('2021-03-01') || this.showInactiveCentres) this.calculateData2(this.child, 'AL Thane', 'ALThane', this.startDate, this.endDate);
    // if (this.startDate < new Date('2021-03-01') || this.showInactiveCentres) this.calculateData2(this.child, 'AL Andheri', 'ALAndheri', this.startDate, this.endDate);

    //by sumeet below 3 lines
    //this.calculateData2(this.child, 'AL Ghatla', 'ALGhatla', this.startDate, this.endDate);
    //this.calculateData2(this.child, 'AL Thane', 'ALThane', this.startDate, this.endDate);
    // this.calculateData2(this.child, 'AL Andheri', 'ALAndheri', this.startDate, this.endDate);
    //sumeet commented till here
    // this.calculateData2(child, 'AL Thane', 'ALThane', this.startDate, this.endDate);
    // this.calculateData2(child, 'AL Ghatla', 'ALGhatla', this.startDate, this.endDate);
    // alert(this.financialData.length)
    // this.getTotalDataThenSetDataSource()
    // this.getTotalDataThenSetDataSource()
  }

  private getTotalDataThenSetDataSource() {
    let totalAdmissions = 0
    let totalDischarge = 0
    let totalIn = 0
    let totalOut = 0
    this.financialData.forEach(data => {
      totalAdmissions = totalAdmissions += data.new_admission
      totalDischarge = totalDischarge += data.discharge
      totalIn = totalIn += data.follow_up_admission
      totalOut = totalOut += data.follow_up_discharge
    })

    // this.calculateData2(child, 'AL Thane', 'ALThane', this.startDate, this.endDate);
    // this.calculateData2(child, 'AL Ghatla', 'ALGhatla', this.startDate, this.endDate);
    // alert(this.financialData.length)
    this.financialData = this.financialData.sort((a, b) => {
      if (a.centreName === b.centreName) {
        return new Date(a.date).getTime() - new Date(b.date).getTime();
      } else {
        return a.centreName.localeCompare(b.centreName);
      }
    });
    let total: FinancialYearReport = {
      centreName: 'Total',
      new_admission: totalAdmissions,
      discharge: totalDischarge,
      follow_up_admission: totalIn,
      follow_up_discharge: totalOut,
    }
    this.financialData.push(total)
    this.dataSource = new MatTableDataSource(this.financialData);
    this.isLoading = false;
  }

  getDate(date: Timestamp): Date {

    return (date as Timestamp).toDate();
  }

  exportexcel() {

    /* assessment-table id is passed over here */
    let element = document.getElementById('excel-table');

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    // const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
    // const ws: XLSX.WorkSheet =XLSX.utils.json_to_sheet(this.receipts)
    ws['!cols'] = [];
    ws['!cols'][19] = {hidden: true};

    /* O1 is your Column in Excel*/

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);


  }

  getFormattedDate(childCode: string, date: any, type: string, i = ''): string {

    if (date == null) {
      // console.error(`error parsing date in ${childCode} at ${type}  `,date)
      return ''
    } else {
      try {
        let y: any
        let d = ''
        if (typeof date != 'string') {
          y = (date as Timestamp).toDate();
        } else {
          y = date
        }
        d = this.datePipe.transform(y, 'dd/MM/yyyy')?.trim()!
        // console.log(y)
        // console.log(d)
        return d
      } catch (e) {
        console.warn('DATE', typeof date)
        console.warn(`error parsing date in ${childCode} at ${type} ${i} `, date)
        console.error(`error parsing date in ${childCode} at ${type} ${i} `, e)
        return ''
      }
    }
  }

  downloadFollowUpAdmissions() {
    const fileName = this.startDate.toDateString() + '-' + this.endDate.toDateString() + " FollowupIn"
    const array = removeDuplicates(this.followUpCountChildArray)
    if (this.useCycles) {
      this.exportCycleList(array, fileName)
      return
    }
    this.processObject(array, fileName)
  }

  downloadFollowUpDischarge() {
    const fileName = this.startDate.toDateString() + '-' + this.endDate.toDateString() + "-FollowupOut"
    const array = removeDuplicates(this.followUpOutCountChildArray)
    if (this.useCycles) {
      this.exportCycleList(array, fileName)
      return
    }
    this.processObject(array, fileName)

  }

  downloadDischarge() {
    const fileName = this.startDate.toDateString() + '-' + this.endDate.toDateString() + "-Discharge"
    const array = removeDuplicates(this.dischargeCountChildArray)
    if (this.useCycles) {
      this.exportCycleList(array, fileName)
      return
    }
    this.processObject(array, fileName)

  }

  downloadAdmissions() {
    const fileName = this.startDate.toDateString() + '-' + this.endDate.toDateString() + "-Admission"
    const array = removeDuplicates(this.admissionsCountChildarray)
    if (this.useCycles) {
      this.exportCycleList(array, fileName)
      return
    }
    this.processObject(array, fileName)

  }


  processObject(array: any[], filename: string): void {
    let data: any[] = array as FullChild[]
    // console.log('initial data',data)

    data.forEach(x => {
      // console.log( x.createdAt)
      // console.log( x.dateOfAdmission)
      // console.log( x.dateOfDischarge)
      // console.log( x.dob)

      if (typeof x.createdAt != undefined) {
        // console.log('into createdAt')
        try {
          x.createdAt = this.getFormattedDate(x.child.code, x.createdAt, 'createdAt')

        } catch (e) {
          // console.log(x.id,e)
        }
        // console.log('createdAt ', x.createdAt)
      }
      if (x.dob != undefined) {
        // console.log('into dob')
        // console.log('into admission')
        try {
          x.dob = this.getFormattedDate(x.childCode, x.dob, 'dob')

        } catch (e) {
          // console.log(x.id,e)
        }
        // console.log('dob ', x.dob)
      }

      if (x.dateOfDischarge != undefined) {
        // console.log('into admission')
        try {
          x.dateOfDischarge = this.getFormattedDate(x.childCode, x.dateOfDischarge, 'dateOfDischarge')

        } catch (e) {
          // console.log(x.id,e)
        }
        // console.log('dateOfAdmission ', x.dateOfAdmission)
      }
      if (x.dateOfAdmission != undefined) {
        // console.log('into admission')
        try {
          x.dateOfAdmission = this.getFormattedDate(x.childCode, x.dateOfAdmission, 'dateofAdmission')

        } catch (e) {
          // console.log(x.id,e)
        }
        // console.log('dateOfAdmission ', x.dateOfAdmission)
      }

      if (x.dischargeDate != undefined) {
        // console.log('into admission')
        try {
          x.dischargeDate = this.getFormattedDate(x.childCode, x.dischargeDate, 'dischargeDate')

        } catch (e) {
          // console.log(x.id,e)
        }
        // console.log('dateOfAdmission ', x.dateOfAdmission)
      }
      try {


        //@ts-ignore
        x.admissionData.forEach((y, i) => {
          if (y.dateOfAdmission != undefined) y.dateOfAdmission = this.getFormattedDate(y.childCode, y.dateOfAdmission, 'AdmissionData>dateOfAdmission', i)
          if (y.dateOfDischarge != undefined) y.dateOfDischarge = this.getFormattedDate(y.childCode, y.dateOfDischarge, 'AdmissionData>dateOfDischarge', i)
          if (y.tentativeDischargeDate != undefined) y.tentativeDischargeDate = this.getFormattedDate(y.childCode, y.tentativeDischargeDate, 'AdmissionData>tentativeDateOfDischarge', i)
        })
      } catch (e) {
        console.warn(x?.childCode, e)
      }
      // x.admissionData.map((y ,i)=> {
      //   if (y.dateOfAdmission != undefined) y.dateOfAdmission = this.getFormattedDate(y.childCode, y.dateOfAdmission, 'AdmissionData>dateOfAdmission',i)
      //   if (y.dateOfDischarge != undefined) y.dateOfDischarge = this.getFormattedDate(y.childCode, y.dateOfDischarge, 'AdmissionData>dateOfDischarge',i)
      //   if (y.tentativeDischargeDate != undefined) y.tentativeDischargeDate = this.getFormattedDate(y.childCode, y.tentativeDischargeDate, 'AdmissionData>tentativeDateOfDischarge',i)
      // })
      x.admissionData = flattenObject(x.admissionData)
      x.guardians = flattenObject(x.guardians)
      x.siblings = flattenObject(x.siblings)
      x.diagnosisSelected = flattenObject(x.diagnosisSelected)
      x.admissionDocuments = null
      x.dischargeDocuments = null
      x.followUpDischargeDocuments = null
      x.followUpAdmissionDocuments = null
      x.sickness = null
      // x=flattenObject(x)
      // x.guardian=flattenObject(x.guardian)

    })
    console.log('DATA==>', data)
    let ydata = data.map(x => flattenObject(x))
    // flattenObject(this.childData[this.childData.length - 1])
    console.log('flatten data', data)
    //
    // convertToCSV(data)

    // const csv = convertToCSV(data);
    // downloadCSV(csv, 'data.csv');
    //     this.flatData = ydata
    // this.show=true
    this.changeObjectBeforeExport(ydata, filename)
    //        this.exportToExcelUsingExcelJS(ydata);
  }

  private changeObjectBeforeExport(ydata: {}[], filename: string) {
    console.log(ydata[0])
    let data = ydata as unknown as any[]
    const FormattedJSON: any = data.map(x => ({
        "Admission Type": x.status,
        "Child Code": x.childCode,
        //  "Child Aadhar No": x.childAadhaar,
        // "Admission Centre": x['admissionData/0/centreCode'],
        "Centre Name": x.centreName,
        //  "Centre Code": x.centreCode,
        // "Base Centre":x.baseCentreName,
        "First Name": x.firstName,
        "Middle Name": x.middleName,
        "Last Name": x.lastName,
        "DOB": x.dob,
        //    "Blood Group": x.bloodGroup,
        "Gender": x.gender,
        // "Date Of Admission":x.admissionData.0.dateOfadmission,
        //   "Age as On Admission": "FUNCTION PENDING",
        //   'Age as On Date': x.age,
        //   'Height at the Time Of Admission': x.height,
        //  'Weight at the Time Of Admission': x.weight,
        //      'Diagnosis': x.diagnosisSelected,
        //     "Prescribed": x.prescribed,
        "Hospital Name": x.hospital,
        //    "File No": x.fileNo,
        //    "Social Worker Name": x.socialName,
        //    "Dr's Name": x.doctorName,
        //    "Allergies": x.allergies,
        //    "Hobbies": x.hobbies,
        //    "Aspiration": x.aspirations,
        //     "Transfer from Center ": '',
        //    "Transfer Date": '',
        'Child Status Type': '',
        //    'Last Discharge Date': x.dateOfDischarge,

        'Unique Admission': x['admissionData/0/dateOfAdmission'],
        //    'Unique Admission In Centre 1': x['admissionData/0/centreCode'],
        //  "Unit 0":x['admissionData/0/currentUnit'],

        //  "Floor 0":'',
        'Unique Discharge Out Date 1': x['admissionData/1/dateOfDischarge'],
        "reason unique": x['admissionData/1/reason'],
        'Followup In Date 1': x['admissionData/2/dateOfAdmission'],
        'Followup In Centre 1': x['admissionData/2/centreCode'],
        // "Unit 1":x['admissionData/2/currentUnit'],
        //  "Floor 1":'',
        'Followup Out Date 1': x['admissionData/3/dateOfDischarge'],
        "reason 1": x['admissionData/3/reason'],
        'Followup In Date 2': x['admissionData/4/dateOfAdmission'],
        'Followup In Centre 2': x['admissionData/4/centreCode'],
        // "Unit 2":x['admissionData/4/currentUnit'],
        // "Floor 2":'',
        'Followup Out Date 2': x['admissionData/5/dateOfDischarge'],
        "reason 2": x['admissionData/5/reason'],

        'Followup In Date 3': x['admissionData/6/dateOfAdmission'],
        'Followup In Centre 3': x['admissionData/6/centreCode'],
        // "Unit 3":x['admissionData/6/currentUnit'],
        // "Floor 3":'',
        'Followup Out Date 3': x['admissionData/7/dateOfDischarge'],
        "reason 3": x['admissionData/7/reason'],

        'Followup In Date 4': x['admissionData/8/dateOfAdmission'],
        'Followup In Centre 4': x['admissionData/8/centreCode'],
        // "Unit 4":x['admissionData/8/currentUnit'],
        // "Floor 4":'',
        'Followup Out Date 4': x['admissionData/9/dateOfDischarge'],

        "reason 4": x['admissionData/9/reason'],

        'Followup In Date 5': x['admissionData/10/dateOfAdmission'],
        'Followup In Centre 5': x['admissionData/10/centreCode'],
        // "Unit 5":x['admissionData/10/currentUnit'],
        //  "Floor 5":'',
        'Followup Out Date 5': x['admissionData/11/dateOfDischarge'],
        "reason 5": x['admissionData/11/reason'],

        'Followup In Date 6': x['admissionData/12/dateOfAdmission'],
        'Followup In Centre 6': x['admissionData/12/centreCode'],
        //  "Unit 6":x['admissionData/12/currentUnit'],
        //  "Floor 6":'',
        'Followup Out Date 6': x['admissionData/13/dateOfDischarge'],
        "reason 6": x['admissionData/13/reason'],

        'Followup In Date 7': x['admissionData/14/dateOfAdmission'],
        'Followup In Centre 7': x['admissionData/14/centreCode'],
        //  "Unit 7":x['admissionData/14/currentUnit'],
        //  "Floor 7":'',
        'Followup Out Date 7': x['admissionData/15/dateOfDischarge'],
        "reason 7": x['admissionData/15/reason'],

        'Followup In Date 8': x['admissionData/16/dateOfAdmission'],
        'Followup In Centre 8': x['admissionData/16/centreCode'],
        //  "Unit 8":x['admissionData/16/currentUnit'],
        //  "Floor 8":'',
        'Followup Out Date 8': x['admissionData/17/dateOfDischarge'],
        "reason 8": x['admissionData/17/reason'],
        'Followup In Date 9': x['admissionData/18/dateOfAdmission'],
        'Followup In Centre 9': x['admissionData/18/centreCode'],
        //  "Unit 9":x['admissionData/18/currentUnit'],
        //  "Floor 9":'',
        'Followup Out Date 9': x['admissionData/19/dateOfDischarge'],
        "reason 9": x['admissionData/19/reason'],
        'Followup In Date 10': x['admissionData/20/dateOfAdmission'],
        'Followup In Centre 10': x['admissionData/20/centreCode'],
        // "Unit 10":x['admissionData/20/currentUnit'],
        //  "Floor 10":'',
        'Followup Out Date 10': x['admissionData/21/dateOfDischarge'],
        "reason 10": x['admissionData/21/reason'],
        'Followup In Date 11': x['admissionData/22/dateOfAdmission'],
        'Followup In Centre 11': x['admissionData/22/centreCode'],
        // "Unit 11":x['admissionData/22/currentUnit'],
        //  "Floor 11":'',
        'Followup Out Date 11': x['admissionData/23/dateOfDischarge'],
        "reason 11": x['admissionData/23/reason'],

        'Followup In Date 12': x['admissionData/24/dateOfAdmission'],
        'Followup In Centre 12': x['admissionData/24/centreCode'],
        //  "Unit 12":x['admissionData/24/currentUnit'],
        //  "Floor 12":'',
        'Followup Out Date 12': x['admissionData/25/dateOfDischarge'],
        "reason 12": x['admissionData/25/reason'],
        'Followup Out Date 13': x['admissionData/27/dateOfDischarge'],
        "reason 13": x['admissionData/27/reason'],
        'Followup Out Date 14': x['admissionData/29/dateOfDischarge'],
        "reason 14": x['admissionData/29/reason'],
        'Followup Out Date 15': x['admissionData/31/dateOfDischarge'],
        "reason 15": x['admissionData/31/reason'],
        'Followup Out Date 16': x['admissionData/33/dateOfDischarge'],
        "reason 16": x['admissionData/33/reason'],
        'Followup Out Date 17': x['admissionData/35/dateOfDischarge'],
        "reason 17": x['admissionData/35/reason'],
        'Followup Out Date 18': x['admissionData/37/dateOfDischarge'],
        "reason 18": x['admissionData/37/reason'],
      }),
    )
    this.saveAsExcelFile(FormattedJSON, filename)

  }

  saveAsExcelFile(data: any[], fileName: string) {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
    this.saveBuffer(excelBuffer, fileName);
    let activity = {
      date: new Date().getTime(),
      section: 'Child Report',
      action: 'Download',

      description: `Excel sheet downloaded by`,
      currentIp: localStorage.getItem('currentip')!
    }
    this.mLogService.addLog(activity)
  }

  private saveBuffer(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {type: 'application/octet-stream'});
    saveAs(data, fileName + '.xlsx');
  }

  CheckData() {
    let arr = this.child.filter(x => x.childCode == "AL-2021-00593")
    let startDate = this.startDate
    let endDate = this.endDate
    let admission: FullChild[] = []
    let discharge: FullChild[] = []
    let firstAdmission = 0
    let firstDischarge = 0
    let admissionCount = 0
    let dischargeCount = 0
    let mUniqueAdmissions: FullChild[] = []
    let mUniqueDischarge: FullChild[] = []
    let mFollowUpIn: FullChild[] = []
    let mFollowUpOut: FullChild[] = []
    arr.forEach(c => {

      c.admissionData.forEach((ad, index) => {
        if (index == 0) {
          if (c.dateOfAdmission.toDate() >= this.startDate && c.dateOfAdmission.toDate() <= this.endDate) {
            mUniqueAdmissions.push(c)
            console.log('Unique Admission found in date range')
          }
          // if(  c.dateOfAdmission.toDate() >= startDate && c.dateOfAdmission.toDate() <= endDate)         admittedChildTable.push({centreName:centreName,childCode: c.childCode,doa: c.dateOfAdmission.toDate()})

        }
        if (index == 1) {
          // @ts-ignore
          if (ad.dateOfDischarge.toDate() >= startDate && ad.dateOfDischarge.toDate() <= endDate) {
            firstDischarge++
            mUniqueDischarge.push(c)
            console.log('Unique Discharge found in date range')

          }

          // @ts-ignore
          // * To show Discharge Count Table
          // if (ad.dateOfDischarge?.toDate() >= startDate && ad.dateOfDischarge.toDate() <= endDate) admittedChildTable.push({
          //     centreName: centreName,
          //     childCode: c.childCode,
          //     doa: ad.dateOfDischarge!.toDate()
          // })

        }
        try {


          if (index >= 2 && index % 2 == 0) {
            // console.log(ad.dateOfAdmission?.toDate())
            const d = ad?.dateOfAdmission?.toDate();
            if (d && d >= startDate && d <= endDate) {

              admissionCount++
              mFollowUpIn.push(c)
              console.log('FollowUpIn found in date range at' + index)

            }
          }
        } catch (e: any) {
          alert(c.childCode + " ERROR IN ADMISSION DATA" + e)
        }
        if (index > 2 && index % 2 != 0) {
          const d = ad?.dateOfAdmission?.toDate();
          if (d && d >= startDate && d <= endDate) {

            dischargeCount++
            mFollowUpOut.push(c)
            console.log('Follow up out found in date range at' + index)

          }
          // console.log(d)

        }
      })
    })

  }

  // onEndDateChanged() {
  //   this.endDate.setHours(23, 59, 0, 0);
  //   console.log('End Dated Is'+this.endDate)
  //
  // }
  // onStartDateChanged() {
  //   this.startDate.setHours(0, 0, 0, 0);
  //   console.log('Start Dated Is'+this.startDate)
  // }


  onStartDateChanged() {
    if (!this.startDate || isNaN(this.startDate.getTime())) return;
    this.startDate.setHours(0, 0, 0, 0);
  }

  onEndDateChanged() {
    if (!this.endDate || isNaN(this.endDate.getTime())) return;
    this.endDate.setHours(23, 59, 0, 0);
  }


  protected readonly PermissionType = PermissionType;
}

function setTimeToMidnight(date: Date): Date {
  date.setHours(0);     // Set hours to 0 (midnight)
  date.setMinutes(0);   // Set minutes to 0
  date.setSeconds(0);   // Set seconds to 0
  date.setMilliseconds(0);  // Set milliseconds to 0
  return date;
}


// @ts-ignore
function flattenObject(obj, prefix = '') {
  const flattened = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const propKey = prefix ? `${prefix}/${key}` : key;
      if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
        Object.assign(flattened, flattenObject(obj[key], propKey));
      } else {
        // @ts-ignore
        flattened[propKey] = obj[key];
      }
    }
  }
  // console.log(flattened)
  return flattened;
}


//CSV

// @ts-ignore
function convertToCSV(obj) {
  const header = Object.keys(obj).join(',');
  const values = Object.values(obj).map(value => {
    if (typeof value === 'object' && !Array.isArray(value)) {
      return JSON.stringify(value);
    }
    return value;
  });
  const row = values.join(',');
  return `${header}\n${row}`;
}

function CalculateAge(dob: Date) {
  let timeDiff = Math.abs(Date.now() - dob.getTime());
  let age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);
  console.log(age)

}


// @ts-ignore
function downloadCSV(csv, filename) {
  const csvData = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
  const csvURL = URL.createObjectURL(csvData);
  const tempLink = document.createElement('a');
  tempLink.href = csvURL;
  tempLink.setAttribute('download', filename);
  tempLink.click();
}

const obj = {
  // Your object goes here
};

const csv = convertToCSV(obj);

// downloadCSV(csv, 'data.csv');

async function processWorkbook(book: Workbook): Promise<void> {
  // @ts-ignore
  for await (const sheet of book) {
    const headers: string[] = [];

    for await (const row of sheet) {
      const item: Record<string, any> = {};

      if (row.model.number === 1) {
        // @ts-ignore

        row.eachCell({includeEmpty: true}, (c, i) => {
          if (i) {
            headers.push(c.value as string);
          }
        });
      }

      if (row.model.number > 1) {
        const rowValues = row.values;
        headers.forEach((header, i) => {
          item[header] = rowValues[i + 1];
        });
      }

      console.log(headers, item);
    }
  }


}

function removeDuplicates(arr: any[]): any[] {
  return arr.reduce((uniqueArray, item) => {
    if (!uniqueArray.includes(item)) {
      uniqueArray.push(item);
    }
    return uniqueArray;
  }, []);
}

// Example usage:

